import axios from 'axios';
import { BASE_URL } from './helpers';

export const SystemPromptsAPI = {
  async get(id: string, source?: 'local' | 'db' | 'effective'): Promise<string> {
    const res = await axios.get<{ id: string; content: string }>(`${BASE_URL}/admin/system-prompts/${id}`, {
      params: source && source !== 'effective' ? { source } : undefined,
    });
    return res.data.content;
  },

  async update(id: string, content: string): Promise<void> {
    await axios.put(`${BASE_URL}/admin/system-prompts/${id}`, { content });
  },
};
